var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumb'),_c('product-list',{style:(_vm.getZoomByScreen()),attrs:{"url":"/products"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }